module.exports = __webpack_public_path__ + "img/icon-app-bitcoin.785fea1b.svg";